import PropTypes from "prop-types";
import { FormattedMessage, FormattedPlural } from "react-intl";
import AtolButtonLabel from "app/pages/Booking/AtolButtonLabel";
import PartnershipWithPFSLabel from "app/pages/.shared/PartnershipWithPFSLabel/PartnershipWithPFSLabel";
import { memo } from "react";
import "./ListingActionbar.scss";
import AmountContainer from "app/pages/.shared/AmountContainer";

const ListingActionbar = ({
	count,
	label,
	enableAtol,
	showPfsMessage,
	fromPrice,
	counterLabelSingular = <FormattedMessage id="listing.products.count.singular" />,
	counterLabelPlural = <FormattedMessage id="listing.products.count.plural" />,
}) => {
	let leftSideComponent = null;

	if (enableAtol) {
		leftSideComponent = (
			<div className="atol-protected" data-testid="atol-protected">
				<AtolButtonLabel />
			</div>
		);
	} else if (showPfsMessage) {
		leftSideComponent = <PartnershipWithPFSLabel />;
	}

	return (
		<h3 className="listing-actionbar">
			{leftSideComponent}
			{label && (
				<div className="listing-actionbar__title" data-testid="listing-actionbar-title">
					{label}
				</div>
			)}
			{count > 0 && (
				<div className="listing-actionbar__counter" data-testid="listing-actionbar-count">
					<span className="listing-actionbar__count">{count}</span>
					<FormattedPlural
						value={count}
						one={counterLabelSingular}
						other={counterLabelPlural}
					/>

					{fromPrice > 0 && (
						<AmountContainer
							amount={fromPrice}
							prefix={<FormattedMessage id="general.from.label" />}
							suffix={
								<FormattedMessage id="general.amount.per.person.suffix.label.short" />
							}
						/>
					)}
				</div>
			)}
			{leftSideComponent && !label && (
				<div className="listing-actionbar__ghost">{leftSideComponent}</div>
			)}
		</h3>
	);
};

ListingActionbar.propTypes = {
	count: PropTypes.number,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.bool]),
	enableAtol: PropTypes.bool,
	showPfsMessage: PropTypes.bool,
	fromPrice: PropTypes.number,
	counterLabelSingular: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element,
		PropTypes.bool,
	]),
	counterLabelPlural: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.bool]),
};

export default memo(ListingActionbar);
